export const headerTranslations = {
  es: {
    inicio: 'Inicio',
    simulaciones: 'Simulaciones',
    guias: 'Guías',
    ayuda: 'Ayuda',
    aboutUs: 'Acerca de Nosotros',
    register: 'Registrarse',
    logout: 'Cerrar Sesión',
    profile: 'Perfil',
    accessibility: 'Accesibilidad',
    textSize: 'Tamaño de texto:',
    small: 'Pequeño',
    medium: 'Mediano',
    large: 'Grande',
    reduceMotion: 'Reducir movimiento',
    language: 'Idioma:',
    highContrast: 'Alto contraste',
    sound: 'Sonido',
    vibration: 'Vibración',
    darkMode: 'Modo oscuro',
    darkModeOn: 'Modo oscuro: Activado',
    darkModeOff: 'Modo oscuro: Desactivado',
  },
  en: {
    inicio: 'Home',
    simulaciones: 'Simulations',
    guias: 'Guides',
    ayuda: 'Help',
    aboutUs: 'About Us',
    register: 'Register',
    logout: 'Logout',
    profile: 'Profile',
    accessibility: 'Accessibility',
    textSize: 'Text size:',
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    reduceMotion: 'Reduce motion',
    language: 'Language:',
    highContrast: 'High contrast',
    sound: 'Sound',
    vibration: 'Vibration',
    darkMode: 'Dark mode',
    darkModeOn: 'Dark mode: On',
    darkModeOff: 'Dark mode: Off',
  },
};
